import { DefaultComparator } from './comparators/default-comparator';
import { GridApi } from 'ag-grid-community';
import {
  DateFilterModel,
  IFilterComparator,
  ConfigureOptionsParams,
  FilterOptions,
  FilterPassParams
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { FilterResultFacade } from '../filter-result-facade';
import { DateFilterService } from '../../../services/date-filter.service';
import { dealDateValueGetter } from '../../../grid/utils/value-getters/deal-date';
import { FilterHandlerBase } from './base/filter-handler-base';

export class DateFilterHandler extends FilterHandlerBase {
  private comparator: IFilterComparator<DateFilterModel>;

  get isInclusiveExclusive(): boolean {
    return false;
  }

  get name(): string {
    return CalendarGridColumnName.Date;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    this.configureDealDateFilter(params.weekOf, params.api);
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return null;
  }

  hasValidDiff(
    options: FilterOptions,
    grid: Partial<DateFilterModel>,
    store: DateFilterModel
  ): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(
    options: FilterOptions
  ): IFilterComparator<DateFilterModel> {
    if (!this.comparator) {
      this.comparator = new DefaultComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }

  configureDealDateFilter(date: string, api: GridApi) {
    const dealDateFilter = api.getFilterInstance(this.name);
    if (dealDateFilter) {
      const dealDateInstance = dealDateFilter.getFrameworkComponentInstance();
      // Runs a method on filter component instance
      dealDateInstance.setUpFilters(date);
    }
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    let dealDateFilterPassed = true;
    const dealDate = params.filters[this.name];
    const data = params.deal;
    if (dealDate) {
      const dateFilterService = new DateFilterService();
      dealDateFilterPassed = dateFilterService.isInSelectedDateRange(
        dealDate.model.vm.weeks,
        dealDateValueGetter(data)
      );
    }
    result.applyDealFilerResult(data.id, this.name, dealDateFilterPassed);

    return dealDateFilterPassed;
  }
}
